import { useCallback, useSyncExternalStore } from "react";

// Shared working plan model persisted in localStorage - mirrors the mobile
// "studio.last_model" AsyncStorage contract so every discipline screen
// (foundation, elevations, schedules …) operates on the chosen plan.
const KEY = "studio.last_model";
const listeners = new Set();

function emit() {
  listeners.forEach((l) => l());
}

export function getWorkingModel() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setWorkingModel(data) {
  try {
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch {}
  emit();
}

export function clearWorkingModel() {
  try {
    localStorage.removeItem(KEY);
  } catch {}
  emit();
}

function subscribe(cb) {
  listeners.add(cb);
  const onStorage = (e) => e.key === KEY && cb();
  window.addEventListener("storage", onStorage);
  return () => {
    listeners.delete(cb);
    window.removeEventListener("storage", onStorage);
  };
}

export function useWorkingModel() {
  const store = useSyncExternalStore(subscribe, () => localStorage.getItem(KEY));
  const value = store ? JSON.parse(store) : null;
  const update = useCallback((d) => setWorkingModel(d), []);
  return [value, update];
}
